import Swal from 'sweetalert2'
import log from 'loglevel'

// This file is no longer being used. Instead Look for SessionResponse.js under src/pages
const sessionToastConfig = Swal.mixin({
  position: 'top',
  showConfirmButton: false,
  timer: 300000,
  timerProgressBar: true,
  customClass: 'swal-margin-top'
  // onOpen: (toast) => {
  //   toast.addEventListener('mouseenter', Swal.stopTimer)
  //   toast.addEventListener('mouseleave', Swal.resumeTimer)
  // }
})
const SessionToast = (callback, refreshToken, logout) => {
  sessionToastConfig.fire({
    title: 'Are you there?',
    html: 'You will be logged out after five minutes of inactivity. You may resume by dismissing this message.'
  }).then((result) => {
    log.debug(result)
    if (result.value) {
      log.info('Timer reset')
      refreshToken()
      return callback()
    } else {
      log.warn('logging out due to inactivity.')
      return logout()
    }
  })
}

export default SessionToast
